import { Alert, Skeleton } from "antd";
import { useState } from "react";
import { CardFamiliare, HrText } from "core/interfaces/components";
import { IFamiliare } from "core/interfaces/data/IAssistitoRequest";
import IFamiliariUtente from "pages/AreaRiservata/FamiliariUtente/IFamiliariUtente";
import "./FamiliariUtente.css";
import { Enhanced } from "utils/ReactUtils";
import CustomTranslation from "components/CustomTranslation/CustomTranslation";

const FamiliariUtente: React.FC<IFamiliariUtente> = ({ familiari,t }) => {
	const [loading] = useState<boolean>(false);


	const familiareSortLogic = (x: IFamiliare, y: IFamiliare) => {
		// comparo il nome e il cognome permetterli in ordine
		var nameOrder: number = 0;
		if (x.Cognome < y.Cognome) {
			nameOrder = -1;
		} else if (x.Cognome > y.Cognome) {
			nameOrder = 1;
		} else if (x.Nome > y.Nome) {
			nameOrder = -1;
		} else if (x.Nome > y.Nome) {
			nameOrder = 1;
		}

		return x.UtenteIsRichiedente ? -1 : nameOrder;
	};

	return (
		<>
			{loading ? (
				<Skeleton active />
			) : (
				<>
					<div id="familiariUtente" className="familiari-list">
						{familiari ? (
							<>
								{familiari.filter((x) => !x.UtenteIsRichiedente).length > 0 ? (
									<>
										<HrText text={t("reservedArea.falimiariUtente.familiare")} />
										{familiari
											.filter((x) => !x.UtenteIsRichiedente)
											.sort(familiareSortLogic)
											.map((familiare, index) => {
												return (
													<div className={`card-container ${familiare.UtenteIsRichiedente ? "user-is-assisted" : ""}`} key={familiare.Matricola}>
														<CardFamiliare familiare={familiare} selected={undefined} key={index} showAddressDetails={true} />
													</div>
												);
											})}
										<div className="datiutente integrazione">
											<CustomTranslation
												t={t}												
												type="contatti"
												i18Key={"reservedArea.datiUtente.integration"}
											/>
										</div>
									</>
								) : (
									<span className="text">{t("reservedArea.falimiariUtente.noUserFound")}</span>
								)}
							</>
						) : (
							<Alert message={t("errorMessages.base")} type="error" showIcon banner />
						)}
					</div>
				</>
			)}
		</>
	);
};

export default Enhanced( FamiliariUtente,{componentNamespace:"FamiliariUtente"});
